<template>
    <modal size="large" @close="$emit('close')">
        <template #header>
            <span class="font-weight-bold">
                Order Details
            </span>
        </template>
        <template #body>
            <div id="private_order_invoice">
                <div class="d-flex justify-content-between">
                    <div class="rounded-lg">
                        <img :src="data.product_data.picture" width="150" alt="" class="rounded" srcset="">
                    </div>
                    <div class="my-auto">
                        <h4 class="font-weight-bold m-0">INVOICE #{{ data.order_id }}</h4>
                        <SMAll>(Pending) Order Date {{ data.product_data.created_at }}</SMAll>
                    </div>
                </div>
                <div class="p-3 mt-4">
                    <div class="d-flex justify-content-between">
                        <div>
                            <span class="font-weight-bold">{{ data.customer_data.name }}</span>
                        </div>
                        <div class="border p-2 rounded">
                            <span class="font-weight-bold" style="text-transform: uppercase;">
                                {{ data.payment_status || (data.payment && data.payment.status) }}
                            </span>
                        </div>
                    </div>
                    <div class="font-weight-bold">
                        <i class="bi bi-telephone-plus"></i>
                        {{ data.customer_data.phone }}
                    </div>
                    <div class="font-weight-bold mt-3">
                        <i class="bi bi-building-add"></i>
                        {{ data.customer_data.address || '-' }}
                    </div>
                    <div class="mt-4 d-flex justify-content-between" style="border-bottom: 1px solid #ddd;">
                        <div>
                            <span class="font-weight-bold">
                                Items
                            </span>
                        </div>
                        <div>
                            <span class="font-weight-bold">
                                Price
                            </span>
                        </div>
                    </div>
                    <div class="mt-4 d-flex justify-content-between" style="border-bottom: 2px dashed #ddd;">
                        <div>
                            <div>
                                <span>{{ data.product_data.name }} <span>(x{{ data.customer_data.quantity }})</span></span>
                            </div>
                        </div>
                        <div>
                            <span class="font-weight-bold">
                                {{ formatMoney(data[getFieldPrice] * data.customer_data.quantity || 0) }}
                            </span>
                        </div>
                    </div>
                    <div class="mt-4 d-flex justify-content-between" style="border-bottom: 2px dashed #ddd;">
                        <div>
                            <span class="font-weight-bold" to="/">
                                Shipping Cost
                            </span>
                        </div>
                        <div>
                            <span class="font-weight-bold">
                                {{ formatMoney(data.product_data.shipping_cost || 0) }}
                            </span>
                        </div>
                    </div>
                    <div class="mt-4 d-flex justify-content-between" style="border-bottom: 2px dashed #ddd;">
                        <div>
                            <span class="font-weight-bold" to="/">
                                Other Cost
                            </span>
                        </div>
                        <div>
                            <span class="font-weight-bold">
                                {{ formatMoney(data.product_data.other_cost || 0) }}
                            </span>
                        </div>
                    </div>

                    <!-- Fee Breakdown (Admin Only) -->
                    <template v-if="isAdmin && data.fee_config">
                    <!-- Service Fee -->
                    <div v-if="data.service_fee" class="mt-4 d-flex justify-content-between" style="border-bottom: 1px dashed #ddd;">
                        <div>
                            <span class="font-weight-bold">
                                Service Fee
                            </span>
                        </div>
                        <div>
                            <span class="font-weight-bold">
                                {{ formatMoney(data.service_fee || 0) }}
                            </span>
                        </div>
                    </div>

                    <!-- Handling Fee Breakdown -->
                    <div v-if="data.fee_config.handling_fee" class="mt-3 d-flex flex-column">
                        <div class="d-flex justify-content-between" style="border-bottom: 1px dashed #ddd;">
                            <div>
                                <span class="font-weight-bold">
                                    SHF (Supplier)
                                </span>
                            </div>
                            <div>
                                <span class="font-weight-bold">
                                    {{ formatMoney(data.fee_config.handling_fee.total_fee_supplier || 0) }}
                                </span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between mt-2" style="border-bottom: 1px dashed #ddd;">
                            <div>
                                <span class="font-weight-bold">
                                    OHF (Platform)
                                </span>
                            </div>
                            <div>
                                <span class="font-weight-bold">
                                    {{ formatMoney(data.fee_config.handling_fee.total_margin_platform || 0) }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- Commission Fee -->
                    <div v-if="data.product_commission_fee" class="mt-3 d-flex justify-content-between" style="border-bottom: 1px dashed #ddd;">
                        <div>
                            <span class="font-weight-bold">
                                Commission Fee
                            </span>
                        </div>
                        <div>
                            <span class="font-weight-bold">
                                {{ formatMoney(data.product_commission_fee || 0) }}
                            </span>
                        </div>
                    </div>
                    </template>

                    <div class="mt-4 d-flex justify-content-between mt-5">
                        <div>
                            <span class="font-weight-bold" to="/">
                                Total
                            </span>
                        </div>
                        <div>
                            <span class="font-weight-bold">
                                {{ formatMoney(totalPayment || 0) }}
                            </span>
                        </div>
                    </div>

                    <div class="d-flex justify-content-center">
                        <div class="invoice__copyright">
                            <span>Powered By</span>
                            <img :src="appLogo" width="150" alt="Ostock.id">
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
			<div>
                <div>
                    <button class="btn btn-light" @click="$emit('close')">Close</button>
                    <button class="btn btn-primary" :class="{ 'is-loading': isPrintLoad }" :disabled="isPrintLoad" @click="printInvoice">Download Invoice</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf';
import { mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';
import { formatMoney, makePDF } from '@/lib/helper';

export default {
	name: 'OrderDetails',
	components: {
		Modal,
	},
	props: {
		data: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			isPrintLoad: false,
		};
	},
	computed: {
		...mapGetters({
			appLogo: 'appLogo',
			isAdmin: 'isAdmin',
			isOwner: 'isOwner',
			isSupplier: 'isSupplier',
			isDropshipper: 'isDropshipper',
		}),
		getFieldPrice() {
			let field = 'product_price';
			if (this.isSupplier || (!this.isOwner && !this.isAdmin)) {
				field = 'base_product_price';
			}
			return field;
		},
		totalPayment() {
			if (this.isAdmin) {
				const productPrice = Number(this.data.total_product_price || 0);
				const handlingFee = Number(this.data.handling_fee || 0);
				const serviceFee = Number(this.data.service_fee || 0);
				const productCommissionFee = Number(this.data.product_commission_fee || 0);
				return productPrice + handlingFee + serviceFee + productCommissionFee;
			}
			const productPrice = (this.data?.[this.getFieldPrice] * this.data?.customer_data?.quantity) ?? 0;
			const otherCost = this.data?.product_data?.other_cost ?? 0;
			const shippingCost = this.data?.product_data?.shipping_cost ?? 0;

			return productPrice + otherCost + shippingCost;
		},
	},
	methods: {
		formatMoney,
		printInvoice() {
			this.isPrintLoad = true;
			const orderId = this.data.order_id;
			const timestamp = new Date().getTime();
			const name = `Invoice-private-order-${orderId}-${timestamp}`;
			const callback = () => {
				this.isPrintLoad = false;
				this.$emit('close');
			};
			setTimeout(() => {
				makePDF(document, 'private_order_invoice', html2canvas, jsPDF, name, callback);
			}, 300);
		},
	},
};
</script>

<style lang="scss" scoped>
.invoice__copyright {
	margin-top: 1em;
	margin-bottom: .5em;
	color: #bbb;
	font-size: .9em;
	font-weight: bold;
	font-style: italic;
	text-align: center;

	span {
		display: inline-block;
		font-size: .9em;
		vertical-align: middle;
	}

	img {
		display: inline-block;
		margin-left: 1em;
		max-width: 125px;
		vertical-align: middle;
	}
}
</style>
